export function sidebarShareFunc() {
  handleCopyButtons();
  handleBookmarkButtons();
  handleMobileShareDrawer();
}

function getCurrentUrl() {
  return window.location.href;
}

function getShareTitle(element) {
  return element.getAttribute('data-share-title') || element.getAttribute('data-bookmark-title') || document.title;
}

function copyText(text, onSuccess, onError) {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(onSuccess).catch(onError);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();

  try {
    if (document.execCommand('copy')) {
      onSuccess();
    } else {
      onError();
    }
  } catch (error) {
    onError();
  } finally {
    document.body.removeChild(textarea);
  }
}

function setTemporaryLabel(element, label) {
  const originalLabel = element.getAttribute('aria-label');
  element.setAttribute('aria-label', label);

  window.setTimeout(() => {
    if (originalLabel) {
      element.setAttribute('aria-label', originalLabel);
    }
  }, 1800);
}

function showToast(message) {
  let toast = document.querySelector('.c-sidebar-copy-toast');

  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'c-sidebar-copy-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.classList.add('is-show');

  if (toast.hideTimer) {
    window.clearTimeout(toast.hideTimer);
  }

  toast.hideTimer = window.setTimeout(() => {
    toast.classList.remove('is-show');
  }, 1800);
}

function handleCopyButtons() {
  document.querySelectorAll('[data-share-copy]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const url = getCurrentUrl();
      copyText(
        url,
        () => {
          setTemporaryLabel(button, '記事URLをコピーしました');
          showToast('URLをコピーしました。');
        },
        () => {
          window.prompt('URLをコピーしてください', url);
        },
      );
    });
  });
}

function handleBookmarkButtons() {
  document.querySelectorAll('[data-bookmark-button]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const title = getShareTitle(button);
      const url = getCurrentUrl();
      const sidebar = window.sidebar;
      const external = window.external;

      if (sidebar && typeof sidebar.addPanel === 'function') {
        sidebar.addPanel(title, url, '');
        return;
      }

      if (external && typeof external.AddFavorite === 'function') {
        try {
          external.AddFavorite(url, title);
          return;
        } catch (error) {
          // Continue to the standards-compliant fallback below.
        }
      }

      const shortcut = navigator.platform.toUpperCase().indexOf('MAC') >= 0 ? 'Command + D' : 'Ctrl + D';
      window.alert(`ブラウザの仕様により、ブックマーク登録画面を自動で開けません。${shortcut} で登録してください。`);
    });
  });
}

function handleMobileShareDrawer() {
  const trigger = document.querySelector('.l-fixed-button__share');
  const panel = document.querySelector('.c-sidebar__item--share');

  if (!trigger || !panel) {
    return;
  }

  const mqMobile = window.matchMedia('(max-width: 1279px)');
  const hiddenTransform = 'translate(0, 101%)';
  const defaultLabel = trigger.textContent.trim() || '記事をシェア';
  const closeLabel = '閉じる';

  if (!panel.id) {
    panel.id = 'sidebar-share-panel';
  }

  trigger.setAttribute('aria-controls', panel.id);
  trigger.setAttribute('aria-haspopup', 'true');

  const isOpen = () => panel.classList.contains('is-show');
  const setTriggerLabel = (open) => {
    trigger.textContent = open ? closeLabel : defaultLabel;
    trigger.setAttribute('aria-label', open ? closeLabel : defaultLabel);
  };

  const closeDrawer = () => {
    panel.classList.remove('is-show');
    trigger.classList.remove('is-active');
    trigger.setAttribute('aria-expanded', 'false');
    setTriggerLabel(false);
    panel.setAttribute('aria-hidden', 'true');
    panel.style.transform = hiddenTransform;
  };

  const openDrawer = () => {
    panel.classList.add('is-show');
    trigger.classList.add('is-active');
    trigger.setAttribute('aria-expanded', 'true');
    setTriggerLabel(true);
    panel.setAttribute('aria-hidden', 'false');
    panel.style.transform = 'translate(0, 0)';
  };

  const syncDrawerState = () => {
    if (mqMobile.matches) {
      if (isOpen()) {
        openDrawer();
      } else {
        closeDrawer();
      }
      return;
    }

    panel.classList.remove('is-show');
    trigger.classList.remove('is-active');
    trigger.setAttribute('aria-expanded', 'false');
    setTriggerLabel(false);
    panel.removeAttribute('aria-hidden');
    panel.style.removeProperty('transform');
  };

  trigger.addEventListener('click', (event) => {
    if (!mqMobile.matches) {
      return;
    }

    event.preventDefault();

    if (isOpen()) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  document.addEventListener('click', (event) => {
    if (!mqMobile.matches || !isOpen()) {
      return;
    }

    if (trigger.contains(event.target) || panel.contains(event.target)) {
      return;
    }

    closeDrawer();
  });

  document.addEventListener('keydown', (event) => {
    if (!mqMobile.matches || !isOpen()) {
      return;
    }

    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  if (typeof mqMobile.addEventListener === 'function') {
    mqMobile.addEventListener('change', syncDrawerState);
  } else if (typeof mqMobile.addListener === 'function') {
    mqMobile.addListener(syncDrawerState);
  }

  syncDrawerState();
}
